import { Users } from '@platform/client';
import EVENTS from '../analytics/events';
import { ROUTES } from '../routes/consts';

export type AccountMenuItem = {
  title: string;
  href: string;
  /** Hrefs that are already absolute (mailto:, the API host's logout url) shouldn't be prefixed
   * with '/platform' the way in-SPA route hrefs need to be when rendered as a plain anchor tag
   * (as opposed to an in-SPA wouter navigation). */
  isAbsolute?: boolean;
  eventName: string;
};

const useAccountMenuItems = (): { isLoading: boolean; items: AccountMenuItem[] } => {
  const { data: user, isSuccess } = Users.useGetCurrentUser();

  const logoutHref = import.meta.env.VITE_API_HOST + '/login/logout';
  const accountSettingsHref = `${ROUTES.DASHBOARD}${ROUTES.ACCOUNT}`;

  if (!isSuccess || !user) {
    return { isLoading: true, items: [] };
  }

  const homeItem: AccountMenuItem = {
    title: 'Home',
    href: ROUTES.DASHBOARD,
    eventName: EVENTS.DASHBOARD.PROFILE_DROPDOWN.HOME_CLICKED,
  };

  const items: AccountMenuItem[] =
    user.accountType === 'organization' ?
      [
        homeItem,
        {
          title: 'Edit Organization',
          href: ROUTES.EDIT_PROFILE,
          eventName: EVENTS.DASHBOARD.ORG_DROPDOWN.EDIT_PROFILE_CLICKED,
        },
        {
          title: 'Preview Your Profile',
          href: `${ROUTES.DIRECTORY}/organizations/${user.organization?.id}`,
          eventName: EVENTS.DASHBOARD.ORG_DROPDOWN.PREVIEW_PROFILE_CLICKED,
        },
        {
          title: 'Invite a team member',
          href: ROUTES.INVITE_ORG_COLLEAGUE,
          eventName: EVENTS.DASHBOARD.ORG_DROPDOWN.INVITE_TEAM_MEMBER_CLICKED,
        },
        {
          title: 'Account settings',
          href: accountSettingsHref,
          eventName: EVENTS.DASHBOARD.PROFILE_DROPDOWN.ACCOUNT_AND_PROFILE_CLICKED,
        },
        {
          title: 'Log out',
          href: logoutHref,
          isAbsolute: true,
          eventName: EVENTS.DASHBOARD.PROFILE_DROPDOWN.LOGOUT_CLICKED,
        },
      ]
    : [
        homeItem,
        {
          title: 'Edit Profile',
          href: ROUTES.EDIT_PROFILE,
          eventName: EVENTS.DASHBOARD.ORG_DROPDOWN.EDIT_PROFILE_CLICKED,
        },
        {
          title: 'Preview Your Profile',
          href: `${ROUTES.DIRECTORY}/professionals/${user.userId}`,
          eventName: EVENTS.DASHBOARD.ORG_DROPDOWN.PREVIEW_PROFILE_CLICKED,
        },
        {
          title: 'Account settings',
          href: accountSettingsHref,
          eventName: EVENTS.DASHBOARD.PROFILE_DROPDOWN.ACCOUNT_AND_PROFILE_CLICKED,
        },
        {
          title: 'Log out',
          href: logoutHref,
          isAbsolute: true,
          eventName: EVENTS.DASHBOARD.PROFILE_DROPDOWN.LOGOUT_CLICKED,
        },
      ];

  return { isLoading: false, items };
};

export default useAccountMenuItems;
